module.exports = __webpack_public_path__ + "img/user.b202cbd5.png";